import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { asChakraVariable } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const {
  IncomingCallButton: { Button: Colors },
} = phoneColorKeys.Phone

export enum IncomingCallButtonVariants {
  Reject = 'reject',
  Accept = 'accept',
  EndAndAccept = 'endAndAccept',
  HoldAndAccept = 'holdAndAccept',
  ParkAndAccept = 'parkAndAccept',
  AcceptWithOverlap = 'acceptWithOverlap',
}

const incomingCallButtonParts = ['button', 'icon', 'text'] as const

const helpers = createMultiStyleConfigHelpers(incomingCallButtonParts)

export const IncomingCallButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    button: {
      flexDirection: 'column',
      flexShrink: 0,
      boxSize: '8.75rem',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingY: '1.25rem',
      paddingX: 0,
      backgroundColor: Colors.Background,
      borderRadius: '0.5rem',
      border: '2px solid',
      borderColor: Colors.Border,
      _hover: {
        backgroundColor: Colors.Hover.Background,
        borderColor: Colors.Hover.Border,
        boxShadow: `0px 4px 8px 0px ${asChakraVariable(Colors.Hover.BoxShadow)}`,
      },
      _active: {
        backgroundColor: Colors.Active.Background,
        borderColor: Colors.Active.Border,
        boxShadow: `${asChakraVariable(Colors.Active.BoxShadow)}`,
      },
    },
    icon: {
      boxSize: '3.75rem',
    },
    text: {
      ...textStyles[textStyleKeys.Body1],
    },
  },
})

const incomingCallButtonName = getName({ IncomingCallButtonStyle })

export const useIncomingCallButtonStyles = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(incomingCallButtonName, props) as MultiStyleType<
    typeof incomingCallButtonParts
  >
}
